export default __webpack_public_path__ + "static/media/iphone_01.f702bbf2.png";